import React, { FunctionComponent } from 'react';
import { Form, FormSubmitType } from '@doveit/lego';
import FormAddressAutoComplete from '../form-address-autocomplete/FormAddressAutoComplete';
import schema from './B2BContactForm.schema';

export interface B2BContactFormModel {
  contactName: string,
  company: string,
  email?: string,
  phoneNumber: string,
  address: string,
}

export interface B2BContactFormProps {
  initialValues?: Partial<B2BContactFormModel>,
  loading?: boolean,
  disabled?: boolean,
  errorMessage?: string,
  successMessage?: string,
  onSubmit: FormSubmitType<B2BContactFormModel>,
}

const B2BContactForm: FunctionComponent<B2BContactFormProps> = ({
  initialValues = {},
  loading,
  disabled,
  errorMessage,
  successMessage,
  onSubmit,
}) => (
  <Form
    initialValues={initialValues}
    validationSchema={schema}
    loading={loading}
    disabled={disabled}
    onSubmit={onSubmit}
  >
    <Form.Item>
      <FormAddressAutoComplete
        name="address"
        label="Indirizzo"
        aria-label="Inserisci indirizzo"
        placeholder="Es: Via Nino Bixio 7, Milano"
        required
      />
    </Form.Item>

    <Form.Item>
      <Form.Input
        name="company"
        label="Ragione sociale"
        placeholder="Es: Dove.it S.r.l."
        aria-label="Inserisci la ragione sociale"
        required
      />
    </Form.Item>

    <Form.Item>
      <Form.Input
        name="contactName"
        label="Referente"
        placeholder="Es: Maria Bianchi"
        aria-label="Inserisci il nome ed il cognome del referente"
        required
      />
    </Form.Item>

    <Form.Item size={{ MD: 1 / 2 }}>
      <Form.Input
        type="tel"
        name="phoneNumber"
        label="Numero di telefono"
        aria-label="Inserisci l'email"
        placeholder="Es: 340 123456789"
        required
      />
    </Form.Item>

    <Form.Item size={{ MD: 1 / 2 }}>
      <Form.Input
        type="email"
        name="email"
        label="Email"
        aria-label="Inserisci l'indirizzo email"
        placeholder="Es: maria.bianchi@azienda.it"
      />
    </Form.Item>

    {errorMessage && (
      <Form.Item>
        <Form.ErrorMessage message={errorMessage} />
      </Form.Item>
    )}

    {successMessage && (
      <Form.Item>
        <Form.SuccessMessage message={successMessage} />
      </Form.Item>
    )}

    <Form.Actions>
      <Form.Submit
        label="Richiedi informazioni"
        aria-label="Richiedi informazioni"
        expanded
      />
    </Form.Actions>
  </Form>
);

export default B2BContactForm;
